import { logout as performLogout } from "@trustpilot/businessapp-login";

import configuration from "../configuration";

export const logout = (options?: { [key: string]: string }, path = "") => {
  performLogout(
    {
      Environment: configuration.Environment,
      CookieDomain: configuration.CookieDomain,
      AuthorizeTrustpilotApiHosts: configuration.AuthorizeTrustpilotApiHosts,
      "TrustpilotApi.Host": configuration["TrustpilotApi.Host"],
      "BusinessAuthentication.Host": `${configuration["BusinessAuthentication.Host"]}${path}`,
      "BusinessAuthentication.ClientId": configuration["BusinessAuthentication.ClientId"],
      "BusinessAppAuthenticationApi.Host": configuration["BusinessAppAuthenticationApi.Host"],
    },
    options,
  );
};
